export default __webpack_public_path__ + "static/media/contact.94d99d24.svg";